import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportButtonComponent {
  @Output() buttonClicked = new EventEmitter();

  constructor() {}
  @Input() isDisabled = false;

  onExportButtonClicked(): void {
    this.buttonClicked.emit();
  }
}
